<template>
  <div class="tw-shadow">
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0" v-if="ready">
      <b-tabs card fill>
        <b-tab v-for="(tab, key) in data" :title="key" :key="key" :active="key === defaultSelected">

          <h6 class="tw-font-bolder tw-mb-0">Positive Infections </h6>
          <!-- <span class="text-secondary tw-text-xs">{{ tab.chartdata.datasets[0].data[0] }} Infected in total</span> -->
          <p class="text-secondary tw-text-xs">
            {{
              key === "Deltamethrin"
                ? ''
                : key === "Beta-cyfluthrin"
                  ? ''
                  : ''
            }}
            {{ totalInfections3Label(key) }}
          </p>
          <doughnut-chart class="k-test" :chartdata="tab.chartdata" :options="tab.options"></doughnut-chart>
          <div id="enrollment-label" style="margin-top: 0em">
            <h1 class="tw-text-4xl tw-font-bolder text-center tw-mb-0">
              {{ key === "Deltamethrin"
                ? total_infections_delta
                : key === "Beta-cyfluthrin"
                  ? total_infections_beta
                  : total_infections
              }}
            </h1>
            <h5 class="tw-font-bolder text-center">Total Infections</h5>
          </div>

          <div v-if="key === defaultSelected" class="text-right">
            <b-button :to="{ name: 'metrics-subject-infected-details'}" variant="outline-secondary">More</b-button>
          </div>
          <div v-else class="text-right">
            <div style="padding: 1.15em;"></div>
          </div>
        </b-tab>
      </b-tabs>
      <div class="tw-mt-auto tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>Positive Infections</template>
          <p>RDT result is positive</p>
          <p>Temperature GTE 37.5</p>
          <p>Positive result GTE 14 days of other positive results</p>
          <p>Not within 10 days of clearance dose</p>
        </info-popover>
      </div>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DoughnutChart from "@/components/charts/DoughnutChart.vue";

import * as _ from 'lodash';

export default {
  mixins: [],
  components: {
    DoughnutChart
  },
  props: {},
  data: function() {
    return {
      ready: false,
      // trigger point for the ET is 658
      trigger_point: 658,
      chartdata: {
        datasets: [],
        labels: ["Eave Tubes", "Control"]
      },
      defaultSelected: "All",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 65,
        circumference: Math.PI,
        rotation: -Math.PI,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 18,
          }
        },
        title: {
          display: false,
          text: "Enrolled Subjects"
        },
        tooltips: {
          bodyFontSize: 14
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      },
      data: {}
    };
  },
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;

      const params = {};

      // use the same API with enrollment chart
      HTTP.get("/eavetubes/metrics/positive-infections-chart/", { params: params })
        .then((response) => {

        that.total_infections = response.data.total_infections;
        that.total_infections_delta = response.data.total_infections_delta;
        that.total_infections_beta = response.data.total_infections_beta;

        // three values such as ET, Control, and upto the trigger point
        // for three tabs such as "Total", "Waiting 11 days", and "Waiting 14 days"
        const chartData = {
          "Cumulative": [
            response.data.et_infections,
            response.data.control_infections,
          ],
          "Deltamethrin": [
            response.data.total_infections_delta_et,
            response.data.total_infections_delta_control,
          ],
          "Beta-cyfluthrin": [
            response.data.total_infections_beta_et,
            response.data.total_infections_beta_control,
          ]
        };

        _.each(chartData, (val, key) => {
          that.data[key] = {
            id: key.replace(' ', '-'),
            chartdata: _.cloneDeep(that.chartdata),
            options: _.cloneDeep(that.options)
          };

          that.data[key].chartdata.datasets.push(
            {
              data: val,
              backgroundColor: ["#37B1CA", "#EB513E", "#eee"]
            }
          );
        });

        that.ready = true;

      }).catch((error) => {
          HandleErrors.HandleErrors(error);
      });
    },
    percentRetained: function(chartdata) {
      let val = _.round((chartdata.datasets[0].data[0] / (chartdata.datasets[0].data[0] + chartdata.datasets[0].data[1])) * 100, 2);
      return _.isNaN(val) ? 0 : val;
    },
    totalInfections3Label(key) {
      const today = new Date().toLocaleDateString();
      if (key === "Deltamethrin") {
        return "2/29/24 through 1/2/25";
      } else if (key === "Beta-cyfluthrin") {
        return `1/3/25 through ${today}(today)`;
      } else {
        return `2/29/24 through ${today}(today)`;
      }
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
#enrollment-label {
  position: absolute;
  top: 68%;
  left: 50%;
  transform: translate(-50%, -50%);
}
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 .5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: .35rem .5rem;
}
</style>